import { render, staticRenderFns } from "./categoryModal.vue?vue&type=template&id=5ab88826&scoped=true&"
import script from "./categoryModal.vue?vue&type=script&lang=js&"
export * from "./categoryModal.vue?vue&type=script&lang=js&"
import style0 from "./categoryModal.vue?vue&type=style&index=0&id=5ab88826&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab88826",
  null
  
)

export default component.exports